import api from './index';

const getShipmentById = (id) => api.get(`/shipment/${id}`);

const getEmployeeShipmentById = (id) => api.get(`/employeeshipment/${id}`);

const updateShipmentStatus = (data) => api.post('/updateShipmentStatus', data);

const updateShipmentItem = (data) => api.post('/updateShipmentItem', data);

const getCustomerStatus = (data) => api.post('/customerStatus', data);

const tokenize = (data) => api.post('/tokenize', data);

const postShipment = (data) => api.post('/shipment', data);

const updateShipment = (data) => api.post('/updateShipment', data);

const updatePickupItem = (data) => api.post('/updatePickupItem', data);

const updateLoadItem = (data) => api.post('/updateLoadItem', data);

const updateOffloadItem = (data) => api.post('/updateOffloadItem', data);

const updateDeliveringItem = (data) => api.post('/updateDeliveringItem', data);

const updateFlag = (data) => api.post('/updateFlag', data);

const getAgent = () => api.get('/getAgent');

export {
  getShipmentById,
  getEmployeeShipmentById,
  updateShipmentStatus,
  updateShipmentItem,
  getCustomerStatus,
  tokenize,
  postShipment,
  updateShipment,
  updatePickupItem,
  updateLoadItem,
  updateOffloadItem,
  updateDeliveringItem,
  updateFlag,
  getAgent,
};
